import logo from "../logo.jpg";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { reset } from "./inmate_list/inmatesSlice";
import PhoneNavDropdown from "./PhoneNavDropdown";
import { Link } from "react-router-dom";
import { hideLoading } from "./inmate_list/inmatesSlice";

var tabs = [
  {
    name: "Basic",
    href: "/scdc-public/",
    current: window.location.pathname == "/scdc-public/" ? true : false,
  },
  {
    name: "Advanced",
    href: "/scdc-public/advanced",
    current: window.location.pathname == "/scdc-public/advanced" ? true : false,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function Header() {
  const dispatch = useDispatch();
  const [render, setRender] = useState(true); // Used to force render
  const [showDrop, setShowDrop] = useState(false);
  // Holds name of current tab to be displayed in title of dropdown
  const [selectedTabName, setSelectedTabName] = useState(() => {
    if (window.location.pathname == "/scdc-public/") {
      return "Basic";
    } else if (window.location.pathname == "/scdc-public/advanced") {
      return "Advanced";
    }
  });
  function setTabName() {
    var tab;
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].current == true) {
        tab = tabs[i];
      }
    }

    setSelectedTabName(tab.name);
  }
  function setTabToCurrent() {
    for (var i = 0; i < tabs.length; i = i + 1) {
      tabs[i].current = !tabs[i].current;
    }
    dispatch(reset()); //Redux funtion to reset inmate list
    dispatch(hideLoading());

    setRender(!render); //Re-render to make sure the tab color is updated after tab is updated to current
    setTabName();
  }

  return (
    <div className="m-auto flex  w-full ">
      <img src={logo} style={{ margin: "5px" }} className="sm:h-20 h-16" />
      <div className="pr-2 ml-1 sm:pl-1 pb-2">
        <div className="sm:text-2xl text-lg mt-1 sm:font-normal sm:w-full w-32 font-semibold ">
          South Carolina
        </div>
        <div className="sm:text-lg sm:w-full   text-sm  ">
          Department of Corrections
        </div>
        <div className=" sm:pl-px text-orange-primary sm:text-sm text-xs semi-bold ">
          INCARCERATED INMATE SEARCH
        </div>
      </div>

      <div className="mt-4 sm:ml-4 ">
        <div className="sm:hidden mt-2" onClick={() => setShowDrop(!showDrop)}>
          <PhoneNavDropdown title={selectedTabName} items={tabs} z={35} />
        </div>
        <div className="hidden sm:block">
          <nav className="flex space-x-4" aria-label="Tabs">
            {tabs.map((tab) => (
              <Link
                key={tab.name}
                to={tab.href}
                onClick={tab.current ? () => {} : setTabToCurrent}
                className={classNames(
                  tab.current
                    ? "bg-blue-100 text-blue-900"
                    : "text-gray-500 hover:text-gray-700",
                  "px-3 py-2 font-medium text-sm rounded-md"
                )}
                aria-current={tab.current ? "page" : undefined}
              >
                {tab.name}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Header;
